/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import {Session} from '../../../components/session/session';

@Component({
  standalone: false,
  selector: 'adn-release-notes-page',
  template: `
    <div class="container container-small releaseNotesContainer">
      <h1 style="font-size: 20px;margin-bottom: 10px;">Release Notes for the Adnuntius Platform</h1>
      <p *ngIf="urlSlug">
        <a [uiSref]="'nude.release-notes'">Show all Release Notes</a>
      </p>
      <adn-release-notes-display [usePrivate]="usePrivate" [urlSlug]="urlSlug"></adn-release-notes-display>
    </div>
  `
})
export class ReleaseNotesPageComponent implements OnInit {
  usePrivate = false;
  urlSlug: string;

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.usePrivate = this.isAuthenticated();
    this.urlSlug = this.uiRouter.globals.params.urlSlug || undefined;
  }

  private isAuthenticated(): boolean {
    const session: any = Session.obtainData();
    return !!session && !_.isEmpty(session) && session.scope === 'NG_API';
  }
}
